/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Agenda_EmptyInputs */

const cs_calendar_agenda_empty = /** @type {(inputs: Calendar_Agenda_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`V tomto rozsahu nejsou úkoly.`)
};

const en_calendar_agenda_empty = /** @type {(inputs: Calendar_Agenda_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tasks in this range.`)
};

/**
* | output |
* | --- |
* | "No tasks in this range." |
*
* @param {Calendar_Agenda_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_agenda_empty = /** @type {((inputs?: Calendar_Agenda_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Agenda_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_agenda_empty(inputs)
	return cs_calendar_agenda_empty(inputs)
});